// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RoleEditQueryVariables = Types.Exact<{
  organizationRoleId: Types.Scalars["ID"]["input"];
}>;

export type RoleEditQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationRoleDetails?: {
    __typename?: "OrganizationRole";
    id: string;
    name: string;
    permissions: Array<{
      __typename?: "OrganizationPermission";
      id: string;
      databaseId?: string | null;
      serverId?: string | null;
      serverGroupId?: string | null;
      view: boolean;
      modify: boolean;
      billing: boolean;
      api: boolean;
      manage: boolean;
      createWorkbooks: boolean;
    }>;
  } | null;
};

export const RoleEditDocument = gql`
  query RoleEdit($organizationRoleId: ID!) {
    getOrganizationRoleDetails(roleId: $organizationRoleId) {
      id
      name
      permissions {
        id
        databaseId
        serverId
        serverGroupId
        view
        modify
        billing
        api
        manage
        createWorkbooks
      }
    }
  }
`;

/**
 * __useRoleEditQuery__
 *
 * To run a query within a React component, call `useRoleEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleEditQuery({
 *   variables: {
 *      organizationRoleId: // value for 'organizationRoleId'
 *   },
 * });
 */
export function useRoleEditQuery(
  baseOptions: Apollo.QueryHookOptions<RoleEditQuery, RoleEditQueryVariables> &
    ({ variables: RoleEditQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RoleEditQuery, RoleEditQueryVariables>(
    RoleEditDocument,
    options,
  );
}
export function useRoleEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RoleEditQuery,
    RoleEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RoleEditQuery, RoleEditQueryVariables>(
    RoleEditDocument,
    options,
  );
}
// @ts-ignore
export function useRoleEditSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RoleEditQuery,
    RoleEditQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RoleEditQuery, RoleEditQueryVariables>;
export function useRoleEditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoleEditQuery, RoleEditQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  RoleEditQuery | undefined,
  RoleEditQueryVariables
>;
export function useRoleEditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoleEditQuery, RoleEditQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RoleEditQuery, RoleEditQueryVariables>(
    RoleEditDocument,
    options,
  );
}
export type RoleEditQueryHookResult = ReturnType<typeof useRoleEditQuery>;
export type RoleEditLazyQueryHookResult = ReturnType<
  typeof useRoleEditLazyQuery
>;
export type RoleEditSuspenseQueryHookResult = ReturnType<
  typeof useRoleEditSuspenseQuery
>;
export type RoleEditQueryResult = Apollo.QueryResult<
  RoleEditQuery,
  RoleEditQueryVariables
>;
